import { SET_LOG_BASE_PAYLOAD } from '@/store/mutation.types';

export default {
    state: () => ({
        logBasePayload: {}
    }),

    actions: {
        set: ({ state, commit }, logBasePayload) => {
            // Merged so as to not lose SSR only values when subsequently navigating
            const mergedPayload = {
                ...state.logBasePayload,
                ...logBasePayload
            };

            commit(SET_LOG_BASE_PAYLOAD, mergedPayload);
        }
    },

    mutations: {
        [SET_LOG_BASE_PAYLOAD]: (state, logBasePayload) => {
            state.logBasePayload = logBasePayload;
        }
    }
};
